import axios from 'axios';
import { useEffect, useState } from 'react';
import { BASE_URL } from '../../insightConfig/insightConfig';

const MySessions = () => {
  const [sessions, setSessions] = useState([]);
  const [activebutton, setActiveButton] = useState('mysessions')
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(BASE_URL + "/igp/getMySessions");
      setSessions(response.data.data);

    }
    fetchData()
  }, [])
  const formatTime = (timeString) => {
    const [hour, minute] = timeString.slice(11, 16).split(":");
    const h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";
    const hour12 = h % 12 || 12;
    return `${hour12}:${minute} ${ampm}`;
  };
  return (
    <>
      {/* <div className="d-flex justify-content-start align-items-center flex-wrap gap-2 bg-light rounded shadow-sm">
        <button className="btn btn-primary px-2 py-1 btn-sm fw-semibold " onClick={() => setActiveButton('mysessions')} >My Sessions</button>
        <button className="btn btn-success px-2 py-1 btn-sm fw-semibold " onClick={() => setActiveButton('feedback_report')} >Feedback Report</button>
        <button className="btn btn-warning px-2 py-1 btn-sm fw-semibold  text-white" onClick={() => setActiveButton('session_video')} >Session Video</button>
      </div> */}
      <div className="container-fluid px-2">
        <div className="card shadow-sm">
          <div className="card-body">
            {
              activebutton == 'mysessions' &&
              <div className="table-responsive">
                <table className="table table-bordered text-center">
                  <thead>
                    <tr>
                      <th colSpan="6" style={{ backgroundColor: "#ff2f00" }} className="text-white fs-6">YOUR INTERVIEW SESSIONS</th>
                    </tr>
                    <tr className="bg-light">
                      <th>S NO.</th>
                      <th>DATE</th>
                      <th>TIME</th>
                      <th>LOCATION</th>
                      <th>REPORT</th>
                      <th>VIDEO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sessions?.map((course, index) => (
                      <tr key={index}>
                        <td>MOCK SESSION {index + 1}</td>
                        <td>{new Date(course.InterviewDate).toLocaleDateString('en-IN')}</td>
                        <td>{formatTime(course.InterviewTime)}</td>
                        <td>{course.Location}</td>
                        <td><button className='btn btn-success btn-sm p-1' onClick={() => window.open(course.FeedbackReport)}> Download</button> </td>
                        <td><button className='btn btn-success btn-sm p-1' onClick={() => window.open(course.SessionVideo)}> Download</button> </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            }
            {
              activebutton == 'feedback_report' &&
              <h1>feedback report</h1>
            }
            {
              activebutton == 'session_video' &&
              <h1>session video</h1>
            }

          </div>
        </div>
      </div>

    </>


  )
}

export default MySessions